import { Pressed, Typography } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const YearPickerStyled = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: 4,
  border: `1px solid ${Colors.gray300}`,
  borderRadius: 4,
  minHeight: 32,
}));

export const YearLabelStyled = styled(Typography)(() => ({
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
}));

export const YearPickerArrowStyled = styled(Pressed)<{
  direction: 'prev' | 'next';
}>(({ direction }) => ({
  paddingInlineStart: direction === 'prev' ? 12 : 0,
  paddingInlineEnd: direction === 'next' ? 12 : 0,
  display: 'flex',
  alignItems: 'center',
}));
